import React, { useState, useRef, useEffect, useContext } from 'react'
import { ChevronDown, CheckCheck, Globe } from 'lucide-react';
import { CantiqueContextAPI } from '../Context/CantiqueContext';

const SidebardFilter = () => {
    const { availableLanguages, selectedLanguage, setSelectedLanguage } = useContext(CantiqueContextAPI);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    // build array of names; first entry is the special "Toutes les langues"
    const languages = ['Toutes les langues', ...availableLanguages.map(l => l.name)];
    
    // label shown in the closed control
    const displayLabel = selectedLanguage ? selectedLanguage : 'Toutes les langues';

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        const handleKey = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', handleOutside);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('mousedown', handleOutside);
            document.removeEventListener('keydown', handleKey);
        };
    }, []);

    const toggle = () => setOpen(o => !o);
    const handleSelect = (lang) => {
        setSelectedLanguage(lang === 'Toutes les langues' ? null : lang);
        setOpen(false);
    };

    // if the chosen language is removed from the backend we should clear
    // the filter to avoid showing no results for no good reason.
    useEffect(() => {
        if (selectedLanguage && !availableLanguages.some(l => l.name === selectedLanguage)) {
            setSelectedLanguage(null);
        }
    }, [availableLanguages, selectedLanguage, setSelectedLanguage]);

    return (
        <div className="SidebardFilter">
            <div className="SidebardFilter__container">
                {/* Pour selectionnez une langue */}
                <div className="SidebardFilter__language">
                    <div className="SidebardFilter__title">
                        <Globe size={17.6} className='SidebardFilter__title__icon' />
                        <span>Langue</span>
                    </div>

                    <div ref={ref} className={`SidebardFilter__language__selected ${open ? 'is-open' : ''}`}>
                        <div
                            className="SidebardFilter__language__selected__select"
                            onClick={toggle}
                            role="button"
                            tabIndex={0}
                            aria-haspopup="listbox"
                            aria-expanded={open}
                        >
                            <span>{displayLabel}</span>
                            <div className="SidebardFilter__language__selected__icon">
                                <ChevronDown className='SidebardFilter__language__selected__select__icon__arrow' size={16} />
                            </div>
                        </div>

                        <div className="SidebardFilter__language__selected__select__pop" role="listbox" aria-hidden={!open}>
                            <div className="SidebardFilter__language__selected__select__pop__closing" onClick={() => setOpen(false)}></div>
                            <div className="SidebardFilter__language__selected__select__pop__list">
                                {languages.map((lang) => (
                                    <div
                                        key={lang}
                                        role="option"
                                        aria-selected={displayLabel === lang}
                                        onClick={() => handleSelect(lang)}
                                        className={`SidebardFilter__language__selected__select__pop__list__item ${displayLabel === lang ? 'selected' : ''}`}
                                    >
                                        <span>{lang}</span>
                                        {displayLabel === lang && <div className="SidebardFilter__language__selected__select__pop__list__item__icon"><CheckCheck size={15} /></div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Fin de la selection de la langue */}
            </div>
        </div>
    )
}

export default SidebardFilter